export const vtsDependencyFields = [
    "ConnectionURL",
    "Username",
    "Password",
    "useConnectionProfile",
    "connectionProfileName",
    "adapter",
    "DatabaseProviderType"
];
